import { useEffect, useState } from 'react'
import Button from '../../components/Button'
import { COLOR_PATH, deleteColor, downloadColorExcelFile, getPageColors, uploadColorExcelFile } from '../../api/colorApi';
import { useNavigate } from 'react-router-dom';
import { AiFillEdit } from "react-icons/ai";
import { AiFillDelete } from "react-icons/ai";
import { useDispatch, useSelector } from 'react-redux';
import { uploadExcelFileAction } from '../../redux/feature/colorSlice';
import LoadMore from '../../components/common/LoadMore';
import Input from '../../components/Input';
import useFirstRender from '../../hooks/FirstRender';
import DeleteModal from '../../components/DeleteModal';
import { toast } from 'react-toastify';
import { ENTITY_IS_IN_USE_MESSAGE, EXCEL_VALIDATION_MESSAGE } from '../../utils/constants';
import { RiFileExcel2Fill } from "react-icons/ri";
import { GoPlus } from "react-icons/go";
import readXlsxFile, { readSheetNames } from 'read-excel-file';
import { FaCloudDownloadAlt } from "react-icons/fa";
import { useApiProgress } from '../../hooks/ApiProgress';
import { pageModel } from '../../utils/model';
import { setColorSearchParamsAction } from '../../redux/feature/searchParamsSlice';

const ColorListPage = ({ title }) => {

    useEffect(() => {
        document.title = "İmperteks / " + title; // Sayfa başlığını güncelle
    }, [title]);

    const isFirstRender = useFirstRender()
    const nav = useNavigate()
    const dispatch = useDispatch()
    const [colorPage, setColorPage] = useState(pageModel)
    const pendingApiCall = useApiProgress('get', `${COLOR_PATH}/page`, false)
    const pendingApiCallDelete = useApiProgress('delete', `${COLOR_PATH}`, false)
    const searchParams = useSelector(state => state.searchParams.color)
    const [isOpen, setIsOpen] = useState(false)
    const [deleteId, setDeleteId] = useState(undefined)
    const [searchTimer, setSearchTimer] = useState();

    useEffect(() => {
        loadColors({ size: 20, page: colorPage.number, ...searchParams })
    }, [])

    const onLoadMore = () => {
        if (!colorPage.last) {
            loadColors({ ...searchParams, lastId: colorPage.content[colorPage.content.length - 1]?.id })
        }
    }

    useEffect(() => {
        !isFirstRender && searching({ ...searchParams, page: 0 })
    }, [searchParams])

    const loadColors = (params) => {
        !pendingApiCall &&
            getPageColors(params)
                .then(res => {
                    setColorPage(prevState => ({ ...res.data, content: [...prevState.content, ...res.data.content] }))
                })
    }

    const searching = async (params) => {
        if (searchTimer) clearTimeout(searchTimer);
        let timer = setTimeout(() => {
            getPageColors(params)
                .then(res => {
                    setColorPage(res.data)
                })
        }, 500);
        setSearchTimer(timer);
    }

    const onClickDelete = () => {
        deleteColor(deleteId)
            .then(res => {
                setIsOpen(false)
                setColorPage(prevState => ({ ...prevState, content: prevState.content.filter(p => p.id !== deleteId) }))
                toast.success('Silindi')
            }).catch(err => {
                toast.error(ENTITY_IS_IN_USE_MESSAGE)
            })
    }

    const uploadExcelFile = async (event) => {
        const file = event.target.files[0];
        if (!Boolean(file)) return;
        const sheets = await readSheetNames(file);
        let rows;
        for (const sheet of sheets) {
            rows = await readXlsxFile(file, { sheet });
            rows.shift();
        }
        const items = []
        for (const row of rows) {
            items.push({
                code: row[0],
                name: row[1],
                hexCode: row[2],
                description: row[3]
            })
        }
        uploadColorExcelFile(items)
            .then(res => {
                toast.success("Kayıtlar güncellendi")
                dispatch(uploadExcelFileAction(res.data))
            }).catch(err => {
                toast.error(EXCEL_VALIDATION_MESSAGE)
            })
    }

    const downloadExcelFile = () => {
        downloadColorExcelFile().then(res => {
            const blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = 'renkler.xlsx';
            a.click();
            window.URL.revokeObjectURL(url);
        }).catch(err => {
            toast.error('Dosya indirilirken hata oluştu!')
        })
    }

    return (
        <div>
            <div className='mb-1 border-b border-zinc-300 dark:border-zinc-500'>
                <label className='text-2xl dark:text-zinc-100'>
                    RENKLER
                </label>
            </div>
            <div className='flex gap-x-2 py-2 sticky top-0 bg-zinc-50 dark:bg-zinc-900'>
                <Button
                    text={<label className='flex items-center gap-x-1'><GoPlus />Yeni Renk</label>}
                    variant='green'
                    onClick={() => nav('/color/add')}
                />
                <label
                    className='bg-emerald-700 hover:bg-emerald-800 disabled:bg-emerald-500 flex items-center gap-x-1 px-2 py-1 text-white text-md rounded-sm'
                    htmlFor='excel-download'
                    onClick={downloadExcelFile}
                >
                    <FaCloudDownloadAlt />
                    <span> Excel İndir</span>
                </label>
                {/* <input className='hidden' id='excel-upload' type='file' accept='.xls, .xlsx' onChange={e => uploadExcelFile(e)} /> */}
            </div>
            <table className='w-full text-left text-zinc-900 mb-10 text-sm'>
                <thead className='text-xs uppercase tracking-wide sticky top-12 bg-zinc-50 dark:bg-zinc-900'>
                    <tr className='dark:text-zinc-100'>
                        <th className='p-2 w-1/12'>Id</th>
                        <th className='p-2 w-2/12'>Renk Kodu</th>
                        <th className='p-2 w-2/12'>Renk Adı</th>
                        <th className='p-2 w-2/12'>Hex Kodu</th>
                        <th className='p-2 w-4/12'>Açıklama</th>
                        <th className='p-2 w-1/12'>Aksiyon</th>
                    </tr>
                </thead>
                <tbody>
                    <tr className='border-b items-center sticky top-20 bg-zinc-50 dark:bg-zinc-900 dark:border-zinc-500'>
                        <td className='px-2'>
                            <Input
                                name="id"
                                placeholder='Id...'
                                value={searchParams.id}
                                onChange={e => dispatch(setColorSearchParamsAction({ key: e.target.name, value: e.target.value }))}
                            />
                        </td>
                        <td className='px-2'>
                            <Input
                                name="code"
                                placeholder='Renk kodu...'
                                value={searchParams.code}
                                onChange={e => dispatch(setColorSearchParamsAction({ key: e.target.name, value: e.target.value }))}
                            />
                        </td>
                        <td className='px-2'>
                            <Input
                                name="name"
                                placeholder='Renk adı...'
                                value={searchParams.name}
                                onChange={e => dispatch(setColorSearchParamsAction({ key: e.target.name, value: e.target.value }))}
                            />
                        </td>
                        <td className='px-2'>
                            <Input
                                name="hexCode"
                                placeholder='Hex kodu...'
                                value={searchParams.hexCode}
                                onChange={e => dispatch(setColorSearchParamsAction({ key: e.target.name, value: e.target.value }))}
                            />
                        </td>
                        <td>
                        </td>
                        <td>
                        </td>
                    </tr>
                    {
                        colorPage.content.map((color, index) => (
                            <tr key={color.id} className='border-b items-center hover:bg-violet-100 duration-150 dark:text-zinc-100 dark:hover:bg-zinc-700 dark:border-zinc-500'>
                                <td className='p-2'># {color.id} </td>
                                <td className='p-2'>{color.code} </td>
                                <td className='p-2'>{color.name}</td>
                                <td className='p-2'>
                                    <div className='flex gap-x-2'>
                                        <input type='color' className='border' value={color.hexCode} disabled />
                                        <label>{color.hexCode}</label>
                                    </div>

                                </td>
                                <td className='p-2 '>{color.description}</td>
                                <td className='p-2 items-center'>
                                    <div className='flex gap-x-3'>
                                        <span className='cursor-pointer hover:scale-125 hover:text-blue-600 duration-150' onClick={() => nav(`/color/edit/${color.id}`)}>
                                            <AiFillEdit />
                                        </span>
                                        <span
                                            className='cursor-pointer hover:scale-125 hover:text-red-600 duration-150'
                                            onClick={() => {
                                                setIsOpen(true)
                                                setDeleteId(color.id)
                                            }}
                                        >
                                            <AiFillDelete />
                                        </span>
                                    </div>
                                </td>
                            </tr>
                        ))
                    }
                </tbody>
            </table>
            <LoadMore page={colorPage} pending={pendingApiCall} onLoadMore={onLoadMore} />
            <DeleteModal
                isOpen={isOpen}
                closeModal={() => setIsOpen(false)}
                onClick={onClickDelete}
                pendingApiCall={pendingApiCallDelete}
            />

        </div >
    )
}

export default ColorListPage